import * as React from 'react';
import List from '@mui/material/List';
import HistoryListContainer from '../items/HistoryListContainer';
import performanceStore from '../../stores/performance';

function PerformanceHistory(props) {

  
  return (
    <List className="muvika-performance-list">
      <HistoryListContainer />
    </List>
  );
}

export default PerformanceHistory;